import CarValuesEstimatorArray from "../../../datasets/car_values_dataset";
import ConfigFile from "../../../datasets/config_file";
import calcRandomInRange from "../../../objects/CommonUse/calc_random_in_range";

export const calculateTradeInValue = (currentGameDate, currentCarYear, carSizeNbr, currentCarCost,
        carBrokenDown) => {
    const tradeInArray = CarValuesEstimatorArray;
    let nbrYearsOld = parseFloat(currentGameDate.substr(0,4)) - +currentCarYear;
    if (nbrYearsOld < 0){
        nbrYearsOld = 0;
    }
    let tradeInAmt = 0;
    var sizeFoundInTable = false;
    for (let i=0; i<tradeInArray.length && sizeFoundInTable === false; i++) {
        if (carSizeNbr === tradeInArray[i].carSizeNbr) {
            sizeFoundInTable = true;
                if (nbrYearsOld <= tradeInArray[i].pctTradeInArr.length) {
                    const sizeTradeInArray = tradeInArray[i].pctTradeInArr;
                    tradeInAmt = currentCarCost * sizeTradeInArray[nbrYearsOld];
                }
        }
        }
        if (sizeFoundInTable === false){
            tradeInAmt = currentCarCost * .90;
    }
   //  The following reduction covers dealer charges for detailing,  inspection costs, and dealer margin scale
    const tradeInAmtReduce = (tradeInAmt * .10);
    tradeInAmt = (tradeInAmt - tradeInAmtReduce).toFixed(2);
    if (carBrokenDown === true){
        const reducedPercent = (calcRandomInRange(28, 32, 0)/100);
        tradeInAmt = (tradeInAmt * reducedPercent);
    }
    if (+tradeInAmt < +ConfigFile.gameChoice.carFloorValue){
        tradeInAmt = ConfigFile.gameChoice.carFloorValue;
    }
    return tradeInAmt;
}
export default calculateTradeInValue;